import Layout from '../../components/feature/Layout';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function TermsPage() {
  // SEO設定
  useSEO({
    title: '利用規約｜キョウコレ',
    description: 'キョウコレの利用規約です。サービスのご利用前に必ずお読みください。',
    keywords: '利用規約,規約,キョウコレ',
    canonical: (import.meta.env.VITE_SITE_URL || 'https://example.com') + '/terms',
    jsonLd: generateWebPageSchema(
      '利用規約｜キョウコレ',
      'キョウコレの利用規約です。サービスのご利用前に必ずお読みください。',
      '/terms'
    ),
  });

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* ページタイトル */}
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          利用規約
        </h1>
        <p className="text-sm text-gray-600 mb-8">
          最終更新日：2025年1月
        </p>

        {/* 前文 */}
        <div className="mb-8 text-gray-700 leading-relaxed">
          <p>
            この利用規約（以下「本規約」といいます）は、キョウコレ（以下「当サイト」といいます）が提供するサービスの利用条件を定めるものです。
            ユーザーの皆様には、本規約に同意いただいた上で、当サイトをご利用いただきます。
          </p>
        </div>

        {/* 各条項 */}
        <div className="space-y-8">
          {/* 第1条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第1条（適用）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 本規約は、当サイトが提供するサービス（以下「本サービス」といいます）の利用に関する条件を、ユーザーと当サイトとの間で定めるものです。
              </p>
              <p>
                2. 当サイトが当サイト上で掲載する本サービスの利用に関するルール、注意事項等は、本規約の一部を構成するものとします。
              </p>
            </div>
          </section>

          {/* 第2条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第2条（サービス内容）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                本サービスは、学習教材・活用レシピの閲覧・投稿・共有を目的としたWebサービスです。主な機能は以下の通りです。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>学習教材・教材サイト・単元ガイドの閲覧</li>
                <li>活用レシピの閲覧・投稿・検索</li>
                <li>学習相談・居場所の悩みの閲覧・投稿</li>
                <li>フィードバックの送信</li>
                <li>マイページ機能（ログインユーザーのみ）</li>
              </ul>
            </div>
          </section>

          {/* 第3条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第3条（アカウント登録）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 本サービスの一部機能を利用するには、アカウント登録が必要です。登録時には、正確かつ最新の情報を提供してください。
              </p>
              <p>
                2. ユーザーは、自己の責任においてアカウント情報（メールアドレス・パスワード等）を管理するものとし、これを第三者に利用させたり、貸与、譲渡、売買等をしてはなりません。
              </p>
              <p>
                3. アカウント情報の管理不十分、使用上の過誤、第三者の使用等による損害の責任は、ユーザーが負うものとします。
              </p>
            </div>
          </section>

          {/* 第4条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第4条（禁止事項）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>法令または公序良俗に違反する行為</li>
                <li>犯罪行為に関連する行為</li>
                <li>当サイトまたは第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為</li>
                <li>当サイトのサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
                <li>当サイトのサービスの運営を妨害するおそれのある行為</li>
                <li>不正アクセスをし、またはこれを試みる行為</li>
                <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
                <li>不正な目的を持って本サービスを利用する行為</li>
                <li>当サイトの他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為</li>
                <li>他のユーザーに成りすます行為</li>
                <li>当サイトが許諾しない本サービス上での宣伝、広告、勧誘、または営業行為</li>
                <li>当サイトのサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
                <li>その他、当サイトが不適切と判断する行為</li>
              </ul>
            </div>
          </section>

          {/* 第5条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第5条（投稿コンテンツの取り扱い）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. ユーザーが本サービスに投稿したコンテンツ（活用レシピ、学習相談、居場所の悩み、フィードバック等）の著作権は、ユーザーに帰属します。
              </p>
              <p>
                2. ユーザーは、投稿コンテンツについて、当サイトに対し、無償で、日本国内外において、非独占的に利用（複製、上映、公衆送信、展示、頒布、譲渡、貸与、翻訳、翻案、出版を含みます）する権利を許諾するものとします。
              </p>
              <p>
                3. ユーザーは、当サイトおよび当サイトから権利を承継しまたは許諾された者に対して、著作者人格権を行使しないことに同意するものとします。
              </p>
              <p>
                4. 当サイトは、投稿コンテンツが本規約に違反していると判断した場合、事前の通知なく削除することができます。
              </p>
            </div>
          </section>

          {/* 第6条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第6条（本サービスの変更・停止・終了）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、ユーザーへの事前の通知なく、本サービスの内容を変更し、または本サービスの提供を中止、終了することができるものとします。
              </p>
              <p>
                2. 当サイトは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
                <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
                <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                <li>その他、当サイトが本サービスの提供が困難と判断した場合</li>
              </ul>
              <p>
                3. 当サイトは、本サービスの変更、停止、中断、終了によってユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
              </p>
            </div>
          </section>

          {/* 第7条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第7条（免責事項）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます）がないことを明示的にも黙示的にも保証しておりません。
              </p>
              <p>
                2. 当サイトは、本サービスに起因してユーザーに生じたあらゆる損害について、一切の責任を負いません。ただし、本サービスに関する当サイトとユーザーとの間の契約（本規約を含みます）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
              </p>
              <p>
                3. 前項ただし書に定める場合であっても、当サイトは、当サイトの過失（重過失を除きます）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当サイトまたはユーザーが損害発生につき予見し、または予見し得た場合を含みます）について一切の責任を負いません。
              </p>
              <p>
                4. 当サイトは、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
              </p>
            </div>
          </section>

          {/* 第8条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第8条（外部サービスとの連携）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 本サービスは、オンライン学習支援プラットフォーム「Boratasu（ボラタス）」へのリンクを含みますが、Boratasuは当サイトと同一の運営主体によって提供されています。
              </p>
              <p>
                2. Boratasuの利用については、Boratasu独自の利用規約が適用されます。
              </p>
              <p>
                3. 本サービスから外部サイトへのリンクが含まれる場合がありますが、当サイトは外部サイトの内容について一切の責任を負いません。
              </p>
            </div>
          </section>

          {/* 第9条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第9条（利用規約の変更）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。
              </p>
              <p>
                2. 変更後の本規約は、当サイトに掲載された時点から効力を生じるものとします。
              </p>
              <p>
                3. 本規約の変更後、本サービスの利用を開始した場合には、変更後の規約に同意したものとみなします。
              </p>
            </div>
          </section>

          {/* 第10条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第10条（個人情報の取り扱い）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                当サイトは、本サービスの利用によって取得する個人情報については、当サイトの「プライバシーポリシー」に従い適切に取り扱うものとします。
              </p>
            </div>
          </section>

          {/* 第11条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第11条（準拠法・管轄裁判所）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 本規約の解釈にあたっては、日本法を準拠法とします。
              </p>
              <p>
                2. 本サービスに関して紛争が生じた場合には、当サイトの所在地を管轄する裁判所を専属的合意管轄とします。
              </p>
            </div>
          </section>
        </div>

        {/* フッター */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-600">
            本規約についてご不明な点がございましたら、
            <a href="/feedback" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">
              フィードバックフォーム
            </a>
            よりお問い合わせください。
          </p>
        </div>
      </div>
    </Layout>
  );
}
